<template>
 
  <ion-content >
  <div id="container"  style="margin-left: 24px;margin-right: 24px;">
    <ion-row>
      <ion-col/>
      <ion-col/>
      <ion-col>
        <button 
          type="button" 
          @click="closeModal()" 
          style="margin-left: 67%;margin-top: 6px; border-radius: 10px;background: #000;"
        >
          <ion-icon :icon="close"></ion-icon> 
        </button>
      </ion-col>
    </ion-row>
    <ion-title> Editar Siniestro </ion-title>
    <ion-form>
      
      <ion-label style="float: left; ">Ingrese el número de afectado</ion-label><br>
      <ion-input type="number" min="1" v-model="num_clientes" @keyup="generarAfectados" @change="generarAfectados"  placeholder="Ingrese el número de afectado" />

      <div v-for="(cliente,key) in clientes" :key="key">
       <ion-label style="float: left; ">Datos del afectado {{key+1}} </ion-label><br>
        
        <ion-input type="text" v-model="cliente.dni"  :placeholder="'Ingrese el dni del afectado '+(key+1)" />
        <ion-input type="text" v-model="cliente.name"  :placeholder="'Ingrese el nombre del afectado '+(key+1)" />
        <ion-input type="text" v-model="cliente.num_poliza"  :placeholder="'Ingrese el número de póliza del afectado '+(key+1)" />
        <ion-input type="text" v-model="cliente.telefono"  :placeholder="'Ingrese el telefono del afectado '+(key+1)" />
        <ion-input type="text" v-model="cliente.movil"  :placeholder="'Ingrese el movil del afectado '+(key+1)" />
        
        <ion-select 
          class="input-text" 
          :placeholder="'Ingrese la compañia del afectado '+(key+1)"
          interface="action-sheet" 
         v-model="clientes[key].compania_id" 
        >
          <ion-select-option 
            v-for="compania in companias" 
            :value="compania.id" 
            :key="compania" 
          >
            {{compania.nombre}}
          </ion-select-option>
        </ion-select>
        
        <ion-input 
          type="text" 
          v-model="cliente.poblacion"  
          :placeholder="'Ingrese la población  del afectado '+(key+1)"  
        />
        <ion-button color="danger" @click="deleteClient(cliente.id)">Eliminar Implicado</ion-button>
      </div>

      <ion-label style="float: left; ">Número de expediente</ion-label><br>
      <ion-input type="text"  v-model="expediente" placeholder="Ingrese número de expediente (opcional)" />

      <ion-label style="float: left; ">ID Exp</ion-label><br>
      <ion-input type="text"  v-model="expediente_id" placeholder="Ingrese id de expediente (opcional)" />

      <ion-label style="float: left;">Fecha del siniestro</ion-label><br>
      <ion-input type="date"  v-model="fecha_siniestro" placeholder="Ingrese la fecha del siniestro" />

      <ion-label style="float: left;">Matrícula</ion-label><br>
      <ion-input type="text"  v-model="matricula" placeholder="Ingrese la matrícula del vehículo" />

      <ion-label style="float: left;">Descripción del Siniestro</ion-label><br>
      <ion-textarea type="text"  v-model="descripcion" placeholder="Ingrese la descripción" />

      <ion-label style="float: left; ">Version del sucedido</ion-label><br>
      <ion-textarea type="text"  v-model="version_suceso" placeholder="Ingrese version del sucedido" />
      
      <ion-label style="float: left; ">Observaciones</ion-label><br>
      <ion-textarea type="text"  v-model="observacion" placeholder="Ingrese la observación" />

      <ion-button color="dark" @click="editSiniesto">Enviar</ion-button>
    </ion-form>
  </div>
</ion-content>

</template>

<script>

import { defineComponent } from 'vue';
import { close } from 'ionicons/icons';
import { modalController, IonInput, IonTextarea, IonSelect, IonSelectOption } from '@ionic/vue';
import axios from 'axios'
import toast from '@/plugins/toast'

export default defineComponent({
  name: 'AgregarColaborador',
  props: ['data_siniestro'],
  components: { IonInput, IonTextarea, IonSelect, IonSelectOption },
  setup() {
    return { close }
  },
  data(){
    return{ 
        num_clientes : 1,
        clientes: [],
        companias: [],
        version_suceso: null,
        observacion: null,
        expediente_id: null,
        descripcion: null,
        fecha_siniestro: null,
        matricula: null,
    }
  },
  mounted(){
    this.matricula = this.data_siniestro.matricula
    this.fecha_siniestro = this.data_siniestro.fecha_siniestro
    this.descripcion = this.data_siniestro.descripcion
    this.version_suceso = this.data_siniestro.version_suceso
    this.expediente = this.data_siniestro.expediente
    this.expediente_id = this.data_siniestro.expediente_id
    this.observacion = this.data_siniestro.observacion
    this.clientes = this.data_siniestro.clientes
    this.num_clientes = this.data_siniestro.clientes.length
    this.getCompanias()
  },
  methods:{
    async closeModal(data = null) {
      const modal = await modalController
      return modal.dismiss(data == null ? 'close-button' : data);
    },
    event($event){
      this[$event.target.id] = $event.target.value
    },
    generarAfectados(){
      this.clientes = [];

      for (var i = 0; i < parseInt(this.num_clientes); i++) {
        
        this.clientes[i]= {
          id : this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].id : null,
          name : this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].name : null ,
          telefono :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].telefono :null,
          dni :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].dni :null,
          num_poliza :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].num_poliza :null,
          compania_id :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].compania_id :null,
          poblacion :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].poblacion :null,
          movil :  this.data_siniestro.clientes[i] !== undefined ? this.data_siniestro.clientes[i].movil : null,
        }
      }
    },
    /*getColaboradores(){
      axios.get('/api/users?all=true&role=Colaborador')
      .then(res => {
        console.log(res.data.data)
        this.colaboradores = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },*/
    getCompanias(){
      axios.get('/api/companias?all=true')
      .then(res => {
        this.companias = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    async editSiniesto(){

      if (this.data_siniestro.clientes.length > this.clientes.length) {
        this.$toast.openToast("No puedes disminuir el número de afectados","error")
        return
      }
      
      var loading = await toast.showLoading()

      await loading.present();
      axios.post('/api/siniestros/'+this.data_siniestro.id,{
        clientes : this.clientes,
        fecha_siniestro: this.fecha_siniestro,
        descripcion: this.descripcion,
        matricula: this.matricula,
        version_suceso: this.version_suceso,
        expediente: this.expediente,
        expediente_id: this.expediente_id,
        observacion: this.observacion,
      })
      .then(data => {
        loading.dismiss()
        this.closeModal('reload')
        this.$toast.openToast("Edición de siniestro exitoso","success")
        console.log(data)
      }).catch(err => {
        loading.dismiss()
        console.log(err)
      })
    },
    async deleteClient(id){
        if (confirm('¿Estás seguro de que quieres eliminar este elemento?')) {
        // Realizar la petición POST aquí
            axios.post('/api/siniestros/remove/user', { 'user_id': id, 'siniestro_id': this.data_siniestro.id })
            .then(response => {
            // Manejar la respuesta si es necesario
            console.log(response.data);
          })
          .catch(error => {
            // Manejar el error si ocurre
            console.error(error);
          });
        }
    }
  }
});
</script>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-select {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
  height: 50px;
}

ion-textarea {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}
</style>
